import { alignLeftCellStyle } from '@client-shared/ui-agGrid';

import {
  periodColumnDefinition,
  enabledFlagColumnDefinition,
  companyCodeColumnDefinition,
  legalEntityColumnDefinition,
  countryTaxTypeColumnDefinition,
  countryTaxTypeDescriptionColumnDefinition,
  chartNameColumnDefinition,
  usTaxTypeColumnDefinition,
  localTaxTypeColumnDefinition,
  functionalCurrencyColumnDefinition,
  taxCurrencyColumnDefinition,
  recordFTCColumnDefinition,
  federalFTCLimitColumnDefinition,
  stateMinimumTaxColumDefinition,
  stateApportionmentRateColumnDefinition,
  statePrePostNOLColumnDefinition,
  NOLColumnDefinition,
  recordVAColumnDefinition,
  currentTaxRateColumnDefinition,
  deferredTaxRateColumnDefinition,
  filingGroupColumnDefinition,
  secondaryTaxColumnDefinition,
  countryCodeColumnDefinition,
  commentColumnDefinition,
  statCurrencyColumnDefinition,
  homeOfficeCompanyCodeColumnDefinition,
  diagnosticsSeverityColumnDefinition,
  diagnosticColumnDefinition,
} from '../columnDefinitions';
import { CellExportFormats } from '@common/xlsxExport/xlsxExport.constants';

const obligationColumnDefinitions = [
  enabledFlagColumnDefinition,
  companyCodeColumnDefinition,
  {
    ...legalEntityColumnDefinition,
    headerName: 'Legal Entity',
  },
  countryCodeColumnDefinition,
  countryTaxTypeColumnDefinition,
  countryTaxTypeDescriptionColumnDefinition,
  chartNameColumnDefinition,
  {
    headerName: 'Connection',
    field: 'connectionName',
    ...alignLeftCellStyle,
    minWidth: 100,
  },
  usTaxTypeColumnDefinition,
  localTaxTypeColumnDefinition,
  functionalCurrencyColumnDefinition,
  statCurrencyColumnDefinition,
  {
    ...taxCurrencyColumnDefinition,
    field: 'taxCurrency',
  },
  secondaryTaxColumnDefinition,
  homeOfficeCompanyCodeColumnDefinition,
  recordFTCColumnDefinition,
  federalFTCLimitColumnDefinition,
  stateMinimumTaxColumDefinition,
  stateApportionmentRateColumnDefinition,
  statePrePostNOLColumnDefinition,
  filingGroupColumnDefinition,
  NOLColumnDefinition,
  recordVAColumnDefinition,
  {
    ...currentTaxRateColumnDefinition,
    customExport: {
      ...currentTaxRateColumnDefinition.customExport,
      format: CellExportFormats.PERCENT_6,
    },
  },
  {
    ...deferredTaxRateColumnDefinition,
    field: 'deferredTaxRate',
    customExport: {
      ...deferredTaxRateColumnDefinition.customExport,
      format: CellExportFormats.PERCENT_6,
    },
  },
  commentColumnDefinition,
];

export const obligationColumnDefinitionForExport = [
  periodColumnDefinition,
  diagnosticsSeverityColumnDefinition,
  diagnosticColumnDefinition,
  ...obligationColumnDefinitions,
];

export default [
  periodColumnDefinition,
  ...obligationColumnDefinitions,
];
